import { render } from "./YoutubeSlider.vue?vue&type=template&id=bf885354"
import script from "./YoutubeSlider.vue?vue&type=script&lang=js"
export * from "./YoutubeSlider.vue?vue&type=script&lang=js"

import "./YoutubeSlider.vue?vue&type=style&index=0&id=bf885354&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__